import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 401 = sesión inválida/expirada -> cerrar sesión.
      // 403 = acción prohibida para el rol actual, pero la sesión sigue siendo válida:
      // no debe desloguear (antes cualquier 403, ej. un técnico sin permiso para listar
      // usuarios, tumbaba la sesión completa por error).
      // Solo redirigir si no estamos ya en el login
      if (!window.location.pathname.includes('/login')) {
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
